import { get } from 'lodash';

/* eslint-disable camelcase */
const prepareParcel = ({
  add_combo,
  address,
  age,
  bath_num,
  esttcv,
  incdnt_cnt,
  lst_sle_dt,
  lst_sle_pr,
  occStatus,
  owner_name,
  rental,
  own_prop_ct,
  open_prmts,
  parcel_id,
  pre,
  rb_flr_ar_num,
  rb_nbed,
  rb_yr_blt,
  taxStatus,
  yx,
  zoning_label,
  cib_flr_ar_num,
  violations,
  open_vio,
  oth_prop_vios,
}) => ({
  violations,
  rental,
  pre,
  age,
  yx,
  add_combo,
  address,
  bath_num,
  esttcv,
  incdnt_cnt,
  lst_sle_dt,
  lst_sle_pr,
  occStatus,
  owner_name,
  own_prop_ct,
  open_prmts,
  parcel_id,
  rb_flr_ar_num,
  rb_nbed,
  rb_yr_blt,
  taxStatus,
  zoning_label,
  cib_flr_ar_num,
  open_vio,
  oth_prop_vios,
});

export const transformResults = (results) => {
  const features = get(results, 'features', []);
  return features.reduce(
    (acc, { properties, geometry }) => {
      acc.parcels.push(prepareParcel(properties));
      return acc;
    },
    {
      parcels: [],
    }
  );
};
